/** Visually verified corrections to supplier gallery ordering. A lead photo
 * must show the complete product; detail/plug/lifestyle images
 * may follow it, never replace it. Aspect ratio alone cannot prove this. */
const CORRECTIONS = [{
  source: 'https://maxx-cold.com/products/chest-freezer-solid-top-mxsh23-6shc',
  model: 'MXSH23.6SHC',
  replaces: ['/product-images/fridge-com-maxx-cold-mxsh23-6shc-1.jpg', '/2653/265304447/.jpg'],
  lead: '/product-leads/maxx-cold-mxsh23-6shc-full-unit.jpg',
}, {
  source: 'https://www.amazon.com/dp/B0C1WVQX69',
  model: 'MP-WR24X10147',
  replaces: ['/product-images/fridge-com-makspro-mp-wr24x10147-1.jpg', '/images/I/416rhzdGZjL.jpg'],
  lead: '/product-images/fridge-com-makspro-mp-wr24x10147-2.jpg',
}] as const

/** Preserve the original detail in the gallery after the approved full unit. */
export function correctProductLead(images: string[]): string[] {
  const correction = CORRECTIONS.find((c) => images.some((url) => {
    try { const path = new URL(url, 'https://fridge.com').pathname; return c.replaces.some((suffix) => path.endsWith(suffix)) }
    catch { return false }
  }))
  return correction ? [correction.lead, ...images.filter((url) => {
    try { return !new URL(url, 'https://fridge.com').pathname.endsWith(correction.lead) }
    catch { return true }
  })] : images
}
